/*
 * @Author: Alan
 * @Date: 2023-06-14 15:11:45
 * @LastEditors: Alan
 * @LastEditTime: 2023-08-16 19:06:03
 * @Description: 404页面
 * @FilePath: /F1-M1-WEB-Code/components/RestrictAccess/ipError.js
 */
import React from 'react';
import Layout from '@/Layout/other';
import { PopUpLiveChat } from '$ACTIONS/util';
//export時會被靜態頁面取代(moveFile.js)
export default function Custom404() {
	return (
		<Layout>
			<div className="error-wrapper">
				<div className="error-img">
					<img src="/cn/img/restrictAccess/restricyAccessImg.png" alt="restricyAccessImg" />
				</div>
				<div className="error-right">
					<div className="error-item">
						<div className="error-block">
							<img src="/cn/img/restrictAccess/block.png" alt="404Icon" />
						</div>
						<p className="error-text">访问受限</p>
						<p style={{ width: '100%', textAlign: 'left',whiteSpace: 'nowrap' }}>
							您的 IP 来自于 : {typeof window !== 'undefined' && window.ipErrorDescription}
						</p>
						<span className="error-mes" style={{ textAlign: 'initial' }}>
							抱歉！您所在的地区受到限制, 无法正常游览我们的网站哦。若有不便之处, 请多多原谅。若您有任何疑问, 请联系我们的在线客服或发邮件
						</span>
						<button className="error-btn" onClick={() => PopUpLiveChat()}>
							<img src="/cn/img/error404/service.png" alt="customerServiceIcon" />
							<span>在线客服</span>
						</button>
						<div className="error-information">
							<div className="error-info-text">
								<span>电子邮箱:</span>
								<a href="#">cs@fun88.com</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
}
